import {
	APICalls,
	getAppClientID,
	getEnvironment,
	getPayload,
	getRedirectURL,
	getXplanTokenURL,
	getXplanURL,
	handleResponseData,
	httpMethods,
} from "./helper";
import axios from "axios";
import { LogError } from "../actions/errorWorker";
import type { SsoCallbackSession } from "../ssoCallback";

export async function getUserFieldDefaults() {
	const payload = getPayload(`${getXplanURL()}${APICalls.UserFieldDefaults}`);
	const response = await axios.post(APICalls.AWSUrl(), payload);
	if (response.data && response.data.isError === false) {
		const data = handleResponseData(response, "");
		if (data && Object.keys(data).length > 0) {
			//Set Defaults
			localStorage.setItem("entity_entity_client_status_default", data["entity_status"]);
			localStorage.setItem("entity_note_type_default", data["note_type"]);
			localStorage.setItem("entity_note_subtype_depend_default", data["note_subtype"]);
			localStorage.setItem("Permission_default", data["note_permission"]);
			localStorage.setItem("task_type_default", data["task_type"]);
			localStorage.setItem("task_subtype_depend_default", data["task_subtype"]);
			localStorage.setItem("task_status_default", data["task_status"]);
			localStorage.setItem("skip_summary", data["skip_summary_page"]);
			localStorage.setItem("hide_postal_code", data["hide_postal_code"]);
			localStorage.setItem("hide_dob", data["hide_dob"]);
		}
	}

	console.log("[SSO Cleanup] Deleting SSO tokens from DynamoDB");
	DeleteSSOTokens(localStorage.getItem("user_story_session_guid"));
}

export function getCustomURLS(): void {
	const payload = getPayload(`${getXplanURL()}${APICalls.FileToURL}`, null, httpMethods.Get);
	axios
		.post(APICalls.AWSUrl(), payload)
		.then((response) => {
			const data = handleResponseData(response, "");
			setCustomPage("custom_note_url", data["note_url"]);
			setCustomPage("custom_task_url", data["task_url"]);
			const hideDocumentNoteCategories =
				data && Object.prototype.hasOwnProperty.call(data, "hide_document_note_categories")
					? String(data["hide_document_note_categories"])
					: "false";
			localStorage.setItem("hide_document_note_categories", hideDocumentNoteCategories);
			return;
		})
		.catch((error) => {
			import("../actions/errorWorker").then((errorWorker) => {
				errorWorker.LogError(error, { payload: payload }, "getCustomURLS", "ERROR");
			});
		});
}

function setCustomPage(key: string, url: string): void {
	if (url && url !== "None" && url !== "" && url !== "null" && url !== "undefined") {
		if (url.indexOf("page=") >= 0) {
			localStorage.setItem(key, url.slice(url.indexOf("page=") + 5));
		} else {
			localStorage.setItem(key, url);
		}
	} else {
		localStorage.removeItem(key);
	}
}

export function logoutXplan(): void {
	const payload = getPayload(`${getXplanURL()}${APICalls.LogoutXplan}`, null, httpMethods.Delete);
	axios.post(APICalls.AWSUrl(), payload);
	return;
}

export function confirmAuth(auth_code: string, session?: SsoCallbackSession) {
	return new Promise((resolve, reject) => {
		const tokenUrl = session ? `${session.xplanUrl}/oauth2/token` : getXplanTokenURL();
		const payload = getPayload(tokenUrl, null, httpMethods.Post, session);
		console.log(`[SSO confirmAuth] Using session GUID from payload: ${payload.user_story_session_guid}`);
		
		payload.data["client_id"] = session ? session.config.app_client_id : getAppClientID();
		payload.data["environment"] = session ? session.config.environment : getEnvironment();
		payload.data["redirect_uri"] = session ? session.config.redirect_url : getRedirectURL();
		payload.data["grant_type"] = "authorization_code";
		payload.data["code"] = auth_code;
		payload.target = "XPLANSSO";
		
		console.log(`[SSO confirmAuth] Sending to backend with GUID: ${payload.user_story_session_guid}`);

		axios
			.post(session ? session.config.aws_url : APICalls.AWSUrl(), payload)
			.then((response) => {
				if (response.data?.isError === false && response.data.data) {
					console.log(`[SSO confirmAuth] Backend successfully wrote tokens to DynamoDB for GUID: ${payload.user_story_session_guid}`);
					console.log(`[SSO confirmAuth] Main window polling will retrieve tokens from DynamoDB`);
					
					// DO NOT store tokens in localStorage here - the main window's polling will retrieve them from DynamoDB
					// This callback window is a separate context and localStorage here won't sync to main window
					
					resolve(true);
				} else {
					console.log(`[SSO confirmAuth] No data returned from backend`);
					reject(new Error(response.data?.message || "No data received from Xplan authentication."));
				}
			})
			.catch((err) => {
				const data = err?.response?.data || {};
				console.log(`[SSO confirmAuth] Error exchanging auth code: ${err.message}`);
				LogError(err, { payload: data, details: err?.toJSON() }, "confirmAuth");
				reject(err);
			});
	});
}

export function DeleteSSOTokens(uss_guid: string) {
	console.log(`[SSO Cleanup] DeleteSSOTokens called for session: ${uss_guid}`);
	if (!uss_guid || uss_guid === "undefined" || uss_guid === "null") {
		console.log("[SSO Cleanup] Invalid session GUID, skipping delete");
		return;
	}
	
	const payload = getPayload(getXplanTokenURL(), null, httpMethods.Post);
	payload.target = "DeleteSSOTokens";
	payload.user_story_session_guid = uss_guid;
	
	console.log("[SSO Cleanup] Sending DeleteSSOTokens request to backend");
	axios.post(APICalls.AWSUrl(), payload)
		.then((response) => {
			console.log("[SSO Cleanup] DeleteSSOTokens response:", response.data);
		})
		.catch((error) => {
			console.error("[SSO Cleanup] DeleteSSOTokens error:", error);
		});
}

// Keep old function name for backward compatibility
export function DeleteFileS3(uss_guid: string) {
	console.log("[SSO Cleanup] DeleteFileS3 called (redirecting to DeleteSSOTokens)");
	DeleteSSOTokens(uss_guid);
}
